module.exports = __webpack_public_path__ + "3830463124082e645a64a01018f4ff25.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/gjjr_g.png
// module id = 281
// module chunks = 3